'use client';

import { type B2BStoreApi, type B2BStoreState, createB2BStore } from '@/stores/B2BStore';
import { type ReactNode, createContext, useContext, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

export const B2BStoreContext = createContext<B2BStoreApi | undefined>(undefined);

export function B2BStoreProvider({
  children,
  initialState,
}: {
  children: ReactNode;
  initialState?: Partial<B2BStoreState>;
}) {
  const [store] = useState(() => createB2BStore(initialState));
  return <B2BStoreContext.Provider value={store}>{children}</B2BStoreContext.Provider>;
}

export function useB2BStore<T = B2BStoreState>(selector: (store: B2BStoreState) => T): T {
  const ctx = useContext(B2BStoreContext);
  if (!ctx) {
    throw new Error('useB2BStore must be used within B2BStoreProvider');
  }

  return useStoreWithEqualityFn(ctx, selector, shallow);
}
